import {h} from "preact";
import FullSite from "./full-site";

export default function GenericPage({Component, path, ...props}) {
	return <FullSite>
		<div class="bg-white min-h-[inherit] text-black max-w-screen overflow-x-auto">
			<Component key={window.location.pathname} {...props} />
		</div>
	</FullSite>
}